module.exports = __webpack_public_path__ + "img/1alB-o-ros.abf02a0f.jpg";